import { handleChangeAllActionType } from "../../actions/handleChangeAction";

const INITIAL_STATE = {
  fraDato: "",
  tilDato: "",
  submitTimestamp: "",
  kjennemerke: "",
};

export default function piggdekkontrollerSubmittedFormReducer(
  state = {
    ...INITIAL_STATE,
  },
  action,
) {
  switch (action.type) {
    case handleChangeAllActionType("RAPPORT_PIGGDEKKONTROLLER_SUBMITTED_FORM"):
      return { ...action.payload };
    default:
      return state;
  }
}
